import { render, staticRenderFns } from "./InspectionsList.vue?vue&type=template&id=6386bcb6&scoped=true&"
import script from "./InspectionsList.vue?vue&type=script&lang=js&"
export * from "./InspectionsList.vue?vue&type=script&lang=js&"
import style0 from "./InspectionsList.vue?vue&type=style&index=0&id=6386bcb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6386bcb6",
  null
  
)

export default component.exports